const ru = {
  zoomTitle: 'Увеличить',
  pinTitle: 'Закрепить',
  unpinTitle: 'Открепить',
  scrollToImageTitle: 'Перейти к изображению',
  newWindowTitle: 'Открыть в новом окне',
};

export default ru;
